import { useLanguage } from '../contexts/LanguageContext'
import type { PageKey } from '../components/AppShell'
export function PlaceholderPage({page}:{page:PageKey}){const{t}=useLanguage();return <section className="placeholder panel"><div className="placeholder-icon">✦</div><span className="eyebrow">SG Flow R1</span><h2>{t(page)}</h2><p>{t('moduleReadyLater')}</p></section>}
